import { lazy, Suspense } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NavBar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import Loader from "./components/Loader/Loader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Checkout from "./components/Checkouts/Checkout";
import ProceedCheckout from "./components/Checkouts/ProceedCheckout";
import Login from "./components/Register/Login";
import Register from "./components/Register/Register";
import DetailProduct from "./components/ProductDetails/DetailProduct";
import ProductListing from "./components/ProductDetails/ProductListing";
import WishList from "./components/WishList/WishList";
import WishListPage from "./pages/WishListPage";
import MyAccount from "./components/More/MyAccount";
import About from "./components/Aboutus/About";
import AboutUsPage from "./pages/AboutUsPage";
import ContactUs from "./components/Aboutus/ContactUs";
import ProfilePage from "./pages/ProfilePage";
import ProceedCheckOutPage from "./pages/ProceedCheckOutPage";
import ProductDetailsPage from "./pages/ProductDetailsPage";
import FAQPage from "./components/More/FaqPage";
import Faq from "./pages/Faq";
import BlogDetail from "./components/More/BlogDetail";
import WholesaleEnquiry from "./components/More/WholeSaleEnquiry";
import EnquiryPage from "./pages/EnquiryPage";
import Return from "./components/Aboutus/Return";
import ReturnPage from "./pages/ReturnPage";
import Contact from "./pages/Contact.jsx";
import NotFound from "./pages/NotFound.jsx";
import Invoice from "./components/Modal/Invoice.jsx";

const Home = lazy(() => import("./pages/Home"));
const Shop = lazy(() => import("./pages/Shop"));
const Cart = lazy(() => import("./pages/Cart"));
const Product = lazy(() => import("./pages/Product"));
function App() {
  return (
    <Suspense fallback={<Loader />}>
      <Router>
        <ToastContainer
          position="top-right"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <NavBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shop/:referenceType/:reference_id" element={<Shop />} />
          <Route path="/shop/:id" element={<Product />} />
          {/* <Route path="/cart" element={<Cart />} /> */}
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/proceedcheckout" element={<ProceedCheckOutPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/productDetails/:product_id" element={<ProductDetailsPage />} />
          <Route path="/products" element={<ProductListing />} />
          <Route path="/wishlist" element={<WishListPage />} />
          <Route path="/account" element={<ProfilePage />} />
          <Route path="/about" element={<AboutUsPage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/wholesale-enquiry" element={<EnquiryPage />} />
          <Route path="/enq" element={<EnquiryPage />} />
          <Route path="/products/:categoryId" element={<Shop />} />
          <Route path="/products/:subcategoryId" element={<Shop />} />
          <Route path="/policy" element={<ReturnPage />} />
          <Route path="/inv" element={<Invoice />} />
   <Route path="*" element={<NotFound/>} />
        </Routes>
        <Footer />
      </Router>
    </Suspense>
  );
}

export default App;
